import { useMemo } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import banners from '@gin-betting/banners';
import { get, upperFirst } from 'lodash';

import { useMemoSelector } from 'hooks';
import { MAPPING_ZONE } from '../../../constants';

const {
    selectors: { makeAttributesByBannerZoneSelector },
} = banners;

interface Input {
    zoneId: string;
    sportEventIds: Set<string>;
}

interface Output {
    matchesIds: string[];
    title: string;
}

const useMobileTopMatchItem = ({ zoneId, sportEventIds }: Input): Output => {
    const { formatMessage } = useIntl();

    const attributes = useMemoSelector(
        makeAttributesByBannerZoneSelector(zoneId),
        {}
    );

    const matchesIds = useMemo(() => Array.from(sportEventIds), [
        sportEventIds,
    ]);

    const location = attributes?.pageLocation ?? '';
    const messageKey: MessageDescriptor | undefined = get(
        MAPPING_ZONE,
        location,
        undefined
    );
    const title = upperFirst(messageKey ? formatMessage(messageKey) : location);

    return {
        matchesIds,
        title,
    };
};

export default useMobileTopMatchItem;
